import { useEffect, useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Button, Divider, Typography, MenuItem, Avatar, IconButton, Popover, InputBase, Dialog, DialogActions, DialogTitle, DialogContent, TextField, InputAdornment } from '@mui/material';
// mocks_
import account from '../../../_mock/account';
import Iconify from '../../../components/iconify/Iconify.js'
import { useNavigate } from 'react-router-dom';
import { getData } from 'src/webService/webService';
import { toast } from 'react-toastify';
import { patchData, putData } from "src/webService/webService";
import { Password } from '@mui/icons-material';


export default function AccountPopover() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const role = sessionStorage.getItem("role");
  const [user, setUser] = useState(null);
  const [passwordOpen, setPasswordOpen] = useState(false)
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const userId = sessionStorage.getItem("userId");
  const token = sessionStorage.getItem("Token");

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userId = sessionStorage.getItem("userId");
        const response = await getData(`users/user/${userId}`); // adjust as needed
        setUser(response.data || response); // based on API shape
      } catch (error) {
        console.error("Failed to fetch user info", error);
      }
    };

    fetchUser();
  }, []);

  const handlePasswordUpdate = async () => {
    debugger;
    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match!');
      return;
    }

    try {
      const result = await putData(`users/user/${userId}`, {
        password: newPassword
      }, token);

      console.log('Password updated:', result);
      alert('Password updated successfully!');
      // Optionally clear the input or close modal
    } catch (error) {
      console.error('Failed to update password:', error);
      alert('Failed to update password. Please try again.');
    }
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePasswordOpen = () => {
    setAnchorEl(false)
    setPasswordOpen(true);
  }

  const handlePasswordClose = () => {
    setPasswordOpen(false);
    setNewPassword('');
    setConfirmPassword('');
  };

  const navigate = useNavigate();

  const logout = async () => {
    sessionStorage.clear();
    navigate('/login');
  };

  const handleOpenAccount = () => {
    navigate(`/${role.toLowerCase()}/dashboard/account`);
  };


  return (
    <>
      <Button
        sx={{
          backgroundColor: "white",
          borderRadius: "50px",
          padding: "1px"
        }}
      >
        <IconButton
          sx={{
            p: 0,
            ...(open && {
              '&:before': {
                zIndex: 1,
                content: "''",
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                position: 'absolute',
                bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
              },
            }),
          }}
        >
          <Avatar src={account.photoURL} alt="photoURL">
            <Iconify icon="iconamoon:profile-light" sx={{ color: "black" }} />
          </Avatar>
        </IconButton>
        <IconButton sx={{ padding: "1px" }}>
          <Avatar sx={{ bgcolor: "white" }}>
            <Iconify icon="ic:baseline-arrow-drop-down" sx={{ color: "black" }} onClick={handleOpen} />
          </Avatar>
        </IconButton>
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 190,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5, cursor: 'pointer' }}>
          <Typography variant="subtitle2" noWrap>
            {user?.role || 'Loading...'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email || ''}
          </Typography>
        </Box>
        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem onClick={handlePasswordOpen} sx={{ m: 1 }}>
          <Iconify icon="material-symbols:lock" sx={{ mr: 1 }} />
          Change Password
        </MenuItem>
        <MenuItem onClick={logout} sx={{ m: 1 }}>
          <Iconify icon="material-symbols:logout" sx={{ mr: 1 }} />
          Logout
        </MenuItem>
      </Popover>
      <Dialog open={passwordOpen}>
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="New Password"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="dense"
            label="Confirm Password"
            type={showConfirmPassword ? 'text' : "password"}
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                    <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePasswordClose} color="secondary" sx={{
            color: 'black',
            '&:hover': {
              backgroundColor: '#ffe4aa', // your desired hover color
              color: 'black'
            },
          }}>Cancel</Button>
          <Button variant="contained" onClick={handlePasswordUpdate}
            sx={{
              color: 'black', backgroundColor: '#ffc860',
              '&:hover': {
                backgroundColor: '#e6ae3a', // your desired hover color
                color: 'white'
              },
            }}
          >
            Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
